import { addHeaderInterceptor as r } from "./add-header-interceptor-factory.js";
import { env as t } from "../../envManager.js";
const a = (e) => e.interceptors.request.use(
  r("apiKey", t.generateGetter("apiKey"))
);
export {
  a as default
};
//# sourceMappingURL=api-key-interceptor.js.map
